import Vue from "vue";
import Router from "vue-router";
import IndexPage from "./views/IndexPage";
import ResumeDraftPage from "./views/ResumeDraftPage";
import ForgotPasswordPage from "./views/ForgotPasswordPage";
import NewCompanyRegistrationPage from "./views/NewCompanyRegistrationPage";
import companyRegistrationSuccessPage from "./views/CompanyRegistrationSuccessPage";
import agreementSuccess from "../mycfm/components/new-company/AgreementSuccess";
import SfgtaAgreementPage from "./views/SfgtaAgreementPage";
import PageNotFound from "../common/components/PageNotFound";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: IndexPage
    },
    {
      path: "/sfgta-agreement",
      name: "sfgtaAgreementPage",
      component: SfgtaAgreementPage
    },
    {
      path: "/resume-draft",
      name: "resumeDraft",
      component: ResumeDraftPage
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgotPasswordPage
    },
    {
      path: "/new-company-registration",
      redirect: "/company-registration"
    },
    {
      path: "/company-registration",
      name: "newCompanyRegistration",
      component: NewCompanyRegistrationPage
    },
    {
      path: "/success",
      name: "success",
      component: companyRegistrationSuccessPage
    },
    {
      path: "/sfgtaSuccess",
      name: "sfgtaSuccess",
      component: agreementSuccess
    },
    {
      path: "/404",
      component: PageNotFound
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});
